import React from 'react';
import { useLocation } from 'react-router-dom';

import Sales_Icon from '../assets/icons/Sales_Icon.png';
import Marketing_Icon from '../assets/icons/Marketing_Icon.png';
import Procurement_Icon from '../assets/icons/Procurement_Icon.png';
import HR_Icon from '../assets/icons/HR_Icon.png';
import Finance_Icon from '../assets/icons/Finance_Icon.png';
import ProjectManagement_Icon from '../assets/icons/ProjectManagement_Icon.png';
import Procurement_image from '../assets/icons/Procurement_Page_image.png';
import Sales_image from '../assets/icons/Sales_Page_image.png';
import Marketing_image from '../assets/icons/Marketing_Page_image.png';
import HR_image from '../assets/icons/HR_Page_image.png';
import Finance_image from '../assets/icons/Finance_Page_image.png';
import ProjectManagement_image from '../assets/icons/ProjectManagement_Page_image.png';


import SalesTitleImage from '../assets/icons/Sales_Title_Image.png';
import { BusinessVerticalContainer, BusinessVerticalContentWrapper, BusinessVerticalDescription, BusinessVerticalIconContainer, BusinessVerticalIconImg, BusinessVerticalIconText, BusinessVerticalLeftSection, BusinessVerticalMobileTitleContainer, BusinessVerticalRightSection, BusinessVerticalRightSectionImg, BusinessVerticalTitle, BusinessVerticalTitleImage } from '../assets/styles/BusinessVertical';



const BusinessVerticalHomeComponent = () => {
  const location = useLocation();

  const isProcurement = location.pathname.includes("procurement");
  const isSales = location.pathname.includes("sales");
  const isMarketing = location.pathname.includes("marketing");
  const isHR = location.pathname.includes("hr");
  const isFinance = location.pathname.includes("finance");
  const isProjectManagement = location.pathname.includes("project-management");

  const procurementData = {
    icon: Procurement_Icon,
    title: "Conquer Spends and Measure Suppliers",
    description: "Procurement doesn’t have to be a juggling act. Devia gives you the tools to control off-contract spending, streamline supplier selection, and measure performance—all with clarity and confidence. From managing budgets to fostering reliable partnerships, we’re here to simplify every step of the process.",
    image: Procurement_image,
    iconText: "Procurement",

  };

  const salesData = {
    icon: Sales_Icon,
    title: "visibility into critical parameters",
    titleImage: SalesTitleImage,
    description: "Navigating today’s fast-paced business environment requires clarity at every step. From on-ground verifications to evaluating the financial credibility of your partners, Devia gives you the insights you need to make confident decisions. Whether you’re assessing warehouses, locations, or dealer performance, our platform simplifies complex processes and provides a clear path forward.",
    image: Sales_image,
    iconText: "Sales",
  };

  const marketingData = {
    icon: Marketing_Icon,
    iconText: "Marketing",
    title: "Boost Loyalty with<br/> Insights",
    image: Marketing_image,
    description: "Loyalty matters. But tracking loyalty program success and turning feedback into actionable insights can be a challenge.That’s where Devia comes in. Our platform empowers your marketing team to assess, adapt, and thrive-helping you maintain goodwill and build lasting customer relationships.",
  };

  const hrData = {
    icon: HR_Icon,
    iconText: "Human Resource",
    title: "Thorough Checks for <br/>Every Role",
    image: HR_image,
    description: "<b>Your workforce is the backbone of your business, and trust is its foundation.</b> Devia helps you build that trust with tailored solutions that evaluate cultural fit, performance, and background-seamlessly and discreetly. From <b>senior executives to white-collared and blue-collared employees </b>, our platform empowers you to make informed hiring decisions with confidence and ease.",
  };

  const financeData = {
    icon: Finance_Icon,
    iconText: "Finance Department",
    title: "Integrated Platform with <br/> Custom Vault",
    image: Finance_image,
    description: "Accessing critical information across departments doesn’t have to be a challenge. With Devia’s tailored document vault and customizable risk checklists, you can streamline processes and stay ahead of potential financial risks. Our platform makes managing documents and data simpler, faster, and more efficient than ever before.",
  };

  const projectManagementData = {
    icon: ProjectManagement_Icon,
    iconText: "Project Management",
    title: "Immediate Insights & <br/> Continuous Monitoring",
    image: ProjectManagement_image,
    description: "Stay ahead of risks and make informed decisions with ease. Devia equips you with instant KYC reports, real-time monitoring, and customizable triggers tailored to your needs. From immediate access to critical information to proactive alerts, our platform ensures seamless alignment between your compliance and operations.",
  };

  const content = isProcurement
    ? procurementData
    : isSales
    ? salesData
    : isMarketing
    ? marketingData
    : isHR
    ? hrData
    : isFinance
    ? financeData
    : isProjectManagement
    ? projectManagementData
    : procurementData; 

  return (
    <BusinessVerticalContainer>
      <BusinessVerticalContentWrapper isSales={isSales}>
        <BusinessVerticalLeftSection isSales={isSales}>
          <BusinessVerticalIconContainer>
            <BusinessVerticalIconImg src={content.icon} alt={content.title} />
            <BusinessVerticalIconText>{content.iconText}</BusinessVerticalIconText> 
          </BusinessVerticalIconContainer>
          {isSales && <BusinessVerticalTitleImage className="titleImage" src={content.titleImage} alt="Sales Title"  loading="lazy"/>}
          <BusinessVerticalTitle className="titleText" dangerouslySetInnerHTML={{ __html: content.title }} />
        </BusinessVerticalLeftSection>
        <BusinessVerticalRightSection isSales={isSales}>
          <BusinessVerticalRightSectionImg src={content.image} alt={content.title} isSales={isSales}  isFinance={isFinance} loading="lazy"/>
        </BusinessVerticalRightSection>
      </BusinessVerticalContentWrapper>
      <BusinessVerticalMobileTitleContainer>
     
        <BusinessVerticalTitle dangerouslySetInnerHTML={{ __html: content.title }} />
      </BusinessVerticalMobileTitleContainer>

      <BusinessVerticalDescription dangerouslySetInnerHTML={{ __html: content.description }} />
    </BusinessVerticalContainer>
  );
};

export default BusinessVerticalHomeComponent;
